/**
 * The HTTP status carried by a rejected calendarFetch call, if any. Mutation
 * errors are typed as `ErrorWrapper<TError>`, which is a union, so reading
 * `.status` directly does not typecheck; this narrows it for analytics.
 */
export function getErrorStatus(error: unknown): number | undefined {
  const status = (error as Partial<{ status: unknown }> | null)?.status;

  return typeof status === 'number' ? status : undefined;
}
